const INBOX = require('INBOX');

INBOX.namespace('classes.Contact', function () {
    return function ({ id = '', displayName = '', emails = [] }) {
        this.id = id;
        this.displayName = displayName;
        this.emails = emails;

        this.getEmailAddress = function (i = 0) {
            const name = this.displayName.trim();
            let address = this.emails[i].address;

            if (!address) return;

            if (name) {
                address = '"' + name.replace(/"/g, '\\"') + '" <' + address + '>';
            }

            return address;
        };
    };
});